import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUi } from '@/lib/store';
import { ThreadPanel } from '@/features/chat/ThreadPanel';
import { useThreadHost } from './liveConversation';

/** The shared thread panel for entity-thread comments (feed cards, issue and event discussions), over any page but Chat. */
export function FloatingThreadPanel() {
  const root = useUi(s => s.threadRootId);
  const openThread = useUi(s => s.openThread);
  const conv = useThreadHost(s => (root ? s.convOf[root] : undefined));
  const { pathname } = useLocation();
  // Leaving the page closes a feed thread, so Chat never shows a panel for a message that isn't in it.
  useEffect(() => () => { if (conv) openThread(null); }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!root || !conv || pathname.startsWith('/chat')) return null;
  return (
    <div className="absolute inset-y-0 right-0 z-30 flex w-full max-w-md border-l border-slate-200 bg-white shadow-2xl dark:border-slate-800 dark:bg-slate-950" data-testid="floating-thread">
      <ThreadPanel conversationId={conv} rootId={root} onClose={() => openThread(null)} />
    </div>
  );
}
